import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashVerificationCodeComponent } from './smash-verification-code/smash-verification-code.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    SmashVerificationCodeComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    SmashVerificationCodeComponent
  ]
})
export class SmashVerificationCodeModule { }
